var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { laggy } from '@juvare/platform-sdk-react/ui/utils';
import useSWR from 'swr';
import { mapNotificationFilterData } from '../clients';
import { useInboxClient } from './useInboxClient';
export function useInbox(request) {
    const inboxClient = useInboxClient();
    return useSWR(['/notifications', request], (_a) => __awaiter(this, [_a], void 0, function* ([, request]) {
        const params = Object.assign(Object.assign({}, mapNotificationFilterData(request.filterData, {
            orderBy: 'received',
            orderDirection: request.sortColumnDesc ? 'desc' : 'asc',
        })), { page: request.limit > 1 ? Math.floor(request.offset / request.limit + 1) : 1, size: request.limit });
        return inboxClient.getList(params);
    }), {
        use: [laggy],
        revalidateOnFocus: false,
    });
}
export function useInboxNotification(notificationId) {
    const inboxClient = useInboxClient();
    return useSWR(['/notification', notificationId], (_a) => __awaiter(this, [_a], void 0, function* ([, notificationId]) { return inboxClient.getNotification(notificationId); }), {
        revalidateOnFocus: false,
    });
}
